import Layout from '@/layout/index.vue'

export const institutionStudentMap = {
  path: '/institutionStudent',
  component: Layout,
  meta: { title: '学员', code: 296028 },
  children: [
    {
      path: 'student',
      component: () => import('@/views/institutionStudent/student/index.vue'),
      meta: { title: '学员管理', code: 468753, drop: true },
      children: [
        {
          path: 'student',
          meta: { title: '学员管理', code: 827902 },
          component: () =>
            import('@/views/institutionStudent/student/student/index.vue'),
          children: [
            {
              path: 'list',
              component: () =>
                import('@/views/institutionStudent/student/student/list.vue'),
              meta: { title: '学员列表', keepAlive: true }
            },
            {
              path: 'add',
              component: () =>
                import('@/views/institutionStudent/student/student/add.vue'),
              meta: { title: '添加学员', code: 364502 }
            },
            {
              path: 'edit',
              component: () =>
                import('@/views/institutionStudent/student/student/add.vue'),
              meta: { title: '编辑学员' }
            },
            {
              path: 'detail',
              component: () =>
                import('@/views/institutionStudent/student/student/add.vue'),
              meta: { title: '学员详情' }
            }
          ]
        }
      ]
    },
    {
      path: 'class',
      component: () => import('@/views/institutionStudent/class/index.vue'),
      meta: { title: '班级管理', code: 480417, drop: true },
      children: [
        {
          path: 'class',
          component: () => import('@/views/institutionStudent/class/class/index.vue'),
          meta: { title: '班级管理' },
          children: [
            {
              path: 'list',
              component: () => import('@/views/institutionStudent/class/class/list.vue'),
              meta: { title: '班级列表', keepAlive: true }
            },
            {
              path: 'add',
              component: () => import('@/views/institutionStudent/class/class/add.vue'),
              meta: { title: '添加班级', code: 907052 }
            },
            {
              path: 'edit',
              component: () => import('@/views/institutionStudent/class/class/add.vue'),
              meta: { title: '编辑班级', code: 441991 }
            },
            {
              path: 'detail',
              component: () => import('@/views/institutionStudent/class/class/add.vue'),
              meta: { title: '班级详情', code: '' }
            }
          ]
        }
      ]
    }
  ]
}
